import request from '@/utils/request'

//重消单商品列表
export function goodsListCXByMember(query) {
    return request({
        url: 'order/goodsListCXByMember',
        method: 'get',
        params: query
    })
}
//重消单验证
export function verificationCX(query) {
    return request({
        url: 'order/verificationCX',
        method: 'get',
        params: query
    })
}
//重消单新增
export function saveCX(data) {
    return request({
        url: 'order/saveCX',
        method: 'post',
        data
    })
}
